import { PinOffOutlineIcon } from './PinOffOutlineIcon';

/**
 * author: At Abbey's side
 * id 0ED785A3-7387-4989-BF3A-11F2F53C81B5
 * name pin-off-outline
 * version: 2.3.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pin-off-outline.svg
 * tags
 */
export const KeepOffOutlineIcon = PinOffOutlineIcon;
export default KeepOffOutlineIcon